/*
 * Controlador único dos drawers (cart/search/mobile/filters).
 * Porta o Aside.tsx (React context) para vanilla JS mantendo as classes
 * .overlay/.expanded do legacy-app.css.
 *
 * Markup esperado:
 *   <div class="overlay" data-drawer="cart">…<button data-drawer-close>…</div>
 *   <button data-drawer-open="cart">…
 */
const drawers = new Map();
let activeDrawer = null;

function open(name) {
  const overlay = drawers.get(name);
  if (!overlay) return;
  if (activeDrawer && activeDrawer !== name) close();
  overlay.classList.add('expanded');
  activeDrawer = name;
}

function close() {
  if (!activeDrawer) return;
  const overlay = drawers.get(activeDrawer);
  if (overlay) overlay.classList.remove('expanded');
  activeDrawer = null;
}

function init() {
  document.querySelectorAll('[data-drawer]').forEach((overlay) => {
    drawers.set(overlay.dataset.drawer, overlay);
  });

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-drawer-open]');
    if (opener) {
      event.preventDefault();
      const name = opener.dataset.drawerOpen;
      open(name);
      document.dispatchEvent(
        new CustomEvent('drawer:open', {detail: {name, opener}}),
      );
      return;
    }
    if (event.target.closest('[data-drawer-close]')) {
      event.preventDefault();
      close();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') close();
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

window.HighDrawer = {open, close};

export {open, close};
